function CommonSvgs() {
    return (<svg
        // eslint-disable-next-line jsx-a11y/aria-props
        aria-name="common"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
        aria-hidden="true"
    >
        <symbol viewBox="0 0 24 24" id="account-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM14.5 9.5C14.5 10.8807 13.3807 12 12 12C10.6193 12 9.5 10.8807 9.5 9.5C9.5 8.11929 10.6193 7 12 7C13.3807 7 14.5 8.11929 14.5 9.5ZM12 13.9961H8.66662C7.97115 13.9961 7.37518 14.7661 7.12537 15.5161C7.73252 16.4634 9.45831 17.9803 12 18.0023C14.5416 18.0243 16.3061 16.3616 16.8745 15.5161C16.6247 14.7661 16.0288 13.9961 15.3333 13.9961H12Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="algo-g">
            <path
                d="M3.51453 19.0712L4.92874 20.4854L7.75717 17.657L6.34295 16.2427L3.51453 19.0712Z"
                fill="#76808F"
            />
            <path
                d="M17.6568 7.75735L20.4852 4.92893L19.071 3.51471L16.2426 6.34314L17.6568 7.75735Z"
                fill="#76808F"
            />
            <path
                d="M4.92889 3.5144L3.51468 4.92862L6.3431 7.75705L7.75732 6.34283L4.92889 3.5144Z"
                fill="#F4C623"
            />
            <path
                d="M17.6569 16.2424L16.2427 17.6566L19.0711 20.4851L20.4853 19.0709L17.6569 16.2424Z"
                fill="#F4C623"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7ZM12 14.1429L9.85714 12L12 9.85714L14.1429 12L12 14.1429Z"
                fill="url(#paint0_linear_71466_20848)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 3H15L21 9V3ZM3 21H9L3 15V21Z"
                fill="#76808F"
            />
            <path d="M15 21H21V15L15 21Z" fill="url(#paint1_linear_71466_20848)" />
            <path d="M9 3H3V9L9 3Z" fill="url(#paint2_linear_71466_20848)" />
            <defs>
                <linearGradient
                    id="paint0_linear_71466_20848"
                    x1={12}
                    y1={7}
                    x2={12}
                    y2={17}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_71466_20848"
                    x1={18}
                    y1={15}
                    x2={18}
                    y2={21}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_71466_20848"
                    x1={6}
                    y1={3}
                    x2={6}
                    y2={9}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="api-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 5C6.13401 5 3 8.13401 3 12C3 15.866 6.13401 19 10 19H13V16H16V13H13V11H16V8H13V5H10ZM21 5H18V19H21V5Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="app-download-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 6V9H4.5V3H5H7.5H16H19V6V9H16V6H7.5ZM5 21H4.5V15H7.5V18H16V15H19V18V21H16H7.5H5ZM13.5088 12.0024L16.0176 12.0078L12.0088 16.0166L8 12.0078L10.5088 11.9832V8H13.5088V12.0024Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="arrow-right-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 11.9988L13.9289 4.92773L12.1612 6.6955L16.2157 10.75L2.99902 10.75L2.99902 13.25L16.2145 13.25L12.1612 17.3033L13.9289 19.0711L21 12L20.9994 11.9994L21 11.9988Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="bnboptions-g">
            <path
                opacity="0.3"
                d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22L12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4L12 2Z"
                fill="#AEB4BC"
            />
            <path
                d="M2 12C2 6.47715 6.47715 2 12 2V4C7.58172 4 4 7.58172 4 12C4 14.2094 4.89434 16.208 6.34315 17.6569L7.75 16.25V20.5H3.5L4.92893 19.0711C3.12038 17.2625 2 14.7611 2 12Z"
                fill="url(#paint0_linear_160_28556)"
            />
            <circle cx={12} cy={12} r={5} fill="#F0B90B" />
            <path
                d="M10.2186 9.69851L11.9799 8.6733L13.7411 9.69851L13.0936 10.0772L11.9799 9.43078L10.8661 10.0772L10.2186 9.69851ZM13.7411 10.9914L13.0936 10.6127L11.9799 11.2592L10.8661 10.6127L10.2186 10.9914V11.7489L11.3323 12.3954V13.6883L11.9799 14.0671L12.6274 13.6883V12.3954L13.7411 11.7489V10.9914ZM13.7411 13.0419V12.2844L13.0936 12.6631V13.4206L13.7411 13.0419ZM14.2009 13.3096L13.0871 13.9561V14.7135L14.8484 13.6883V11.6379L14.2009 12.0167V13.3096ZM13.5533 10.345L14.2009 10.7237V11.4812L14.8484 11.1025V10.345L14.2009 9.96624L13.5533 10.345ZM11.3323 14.2303V14.9878L11.9799 15.3665L12.6274 14.9878V14.2303L11.9799 14.6091L11.3323 14.2303ZM10.2186 13.0419L10.8661 13.4206V12.6631L10.2186 12.2844V13.0419ZM11.3323 10.345L11.9799 10.7237L12.6274 10.345L11.9799 9.96624L11.3323 10.345ZM9.75885 10.7237L10.4064 10.345L9.75885 9.96624L9.11133 10.345V11.1025L9.75885 11.4812V10.7237ZM9.75885 12.0167L9.11133 11.6379V13.6883L10.8726 14.7135V13.9561L9.75885 13.3096V12.0167Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28556"
                    x1={7}
                    y1={2}
                    x2={7}
                    y2="20.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="bot-g">
            <path opacity="0.3" d="M12 17L9 14H15L12 17Z" fill="#AEB4BC" />
            <path
                d="M9 14L7 14L3 18V21H12V17L9 14Z"
                fill="url(#paint0_linear_160_28684)"
            />
            <path
                d="M12 17V21H21V18L17 14L15 14L12 17Z"
                fill="url(#paint1_linear_160_28684)"
            />
            <rect
                width={11}
                height="2.75"
                transform="matrix(1 0 0 -1 6.5 10.5)"
                fill="url(#paint2_linear_160_28684)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3.25C14.4853 3.25 16.5 5.26472 16.5 7.75V12.25H7.5V7.75C7.5 5.26472 9.51472 3.25 12 3.25Z"
                fill="url(#paint3_linear_160_28684)"
            />
            <path
                d="M12 3.25C14.4853 3.25 16.5 5.26472 16.5 7.75V12.25H12V3.25Z"
                fill="#F0B90B"
            />
            <path
                opacity="0.3"
                d="M4 6.75L3 5.75L2 6.75L3 7.75L4 6.75Z"
                fill="#AEB4BC"
            />
            <path
                opacity="0.3"
                d="M20.5 4.75L21.25 5.5L22 4.75L21.25 4L20.5 4.75Z"
                fill="#AEB4BC"
            />
            <path
                opacity="0.3"
                d="M18.25 12.75L18.75 13.25L19.25 12.75L18.75 12.25L18.25 12.75Z"
                fill="#AEB4BC"
            />
            <circle
                cx="1.375"
                cy="1.375"
                r="1.375"
                transform="matrix(1 0 0 -1 12.75 10.5)"
                fill="url(#paint4_linear_160_28684)"
            />
            <circle
                cx="1.375"
                cy="1.375"
                r="1.375"
                transform="matrix(1 0 0 -1 8.5 10.5)"
                fill="url(#paint5_linear_160_28684)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28684"
                    x1="7.5"
                    y1={21}
                    x2="7.5"
                    y2={14}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_160_28684"
                    x1="16.5"
                    y1={14}
                    x2="16.5"
                    y2={21}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_160_28684"
                    x1="5.5"
                    y1={0}
                    x2="5.5"
                    y2="2.75"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_160_28684"
                    x1={12}
                    y1="12.25"
                    x2={12}
                    y2="3.25"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_160_28684"
                    x1="1.375"
                    y1={0}
                    x2="1.375"
                    y2="2.75"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_160_28684"
                    x1="1.375"
                    y1={0}
                    x2="1.375"
                    y2="2.75"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="btcoptions-g">
            <path
                opacity="0.3"
                d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22L12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4L12 2Z"
                fill="#AEB4BC"
            />
            <path
                d="M2 12C2 6.47715 6.47715 2 12 2V4C7.58172 4 4 7.58172 4 12C4 14.2094 4.89434 16.208 6.34315 17.6569L7.75 16.25V20.5H3.5L4.92893 19.0711C3.12038 17.2625 2 14.7611 2 12Z"
                fill="url(#paint0_linear_160_28483)"
            />
            <path
                d="M16.8512 13.2082C16.1861 15.8905 13.4667 17.5162 10.7916 16.8512C8.11646 16.1861 6.48332 13.4668 7.1484 10.7918C7.81348 8.10945 10.5255 6.48377 13.208 7.14882C15.8905 7.82126 17.5162 10.5332 16.8512 13.2082Z"
                fill="#F6921A"
            />
            <path
                d="M14.1663 11.2567C14.2624 10.5917 13.7599 10.237 13.0652 9.99315L13.2869 9.09164L12.7401 8.95124L12.5184 9.83058C12.3706 9.79364 12.2228 9.76408 12.0824 9.72713L12.3041 8.8404L11.7572 8.7L11.5355 9.60151C11.4173 9.57195 11.2991 9.54978 11.1882 9.52023L10.4345 9.3281L10.2867 9.91187C10.2867 9.91187 10.6931 10.0079 10.6857 10.0079C10.9074 10.067 10.9518 10.2074 10.9444 10.3257L10.6857 11.3528C10.7005 11.3602 10.7227 11.3602 10.7448 11.3676C10.7301 11.3602 10.7079 11.3602 10.6857 11.3528L10.3236 12.7938C10.2941 12.8603 10.2276 12.9637 10.0724 12.9268C10.0798 12.9342 9.67333 12.8307 9.67333 12.8307L9.3999 13.4588L10.1167 13.6362C10.2497 13.6731 10.3827 13.7027 10.5084 13.7396L10.2793 14.6485L10.8261 14.7889L11.0478 13.8874C11.1956 13.9317 11.3434 13.9687 11.4838 13.9982L11.2621 14.8924L11.809 15.0328L12.0381 14.1239C12.9766 14.3012 13.6786 14.2273 13.9742 13.3849C14.2106 12.7051 13.9594 12.3134 13.4717 12.0548C13.8264 11.9809 14.0924 11.7445 14.1663 11.2567ZM12.91 13.0154C12.7401 13.6953 11.5947 13.3258 11.2178 13.2371L11.5208 12.0326C11.8976 12.1213 13.0874 12.306 12.91 13.0154ZM13.08 11.2494C12.9248 11.8701 11.9715 11.5523 11.6612 11.4784L11.9346 10.3848C12.245 10.4587 13.2426 10.5991 13.08 11.2494Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28483"
                    x1={7}
                    y1={2}
                    x2={7}
                    y2="20.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="calendar-g">
            <path
                d="M3 3.99999L3 7.99998L21 7.99998V3.99999L3 3.99999Z"
                fill="url(#paint0_linear_160_28744)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.5 5.99998L17.5 1.99998L16.5 1.99998L16.5 5.99998L17.5 5.99998Z"
                fill="#76808F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 5.99998L7.5 1.99998L6.5 1.99998L6.5 5.99998L7.5 5.99998Z"
                fill="#76808F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 8.00006V21.0001L3 21.0001L3 8.00006L21 8.00006ZM4.99995 10.0001H8.99995V14.0001H4.99995V10.0001ZM9.99995 10.0002H14V14.0002H9.99995V10.0002ZM19 10.0002H15V14.0002H19V10.0002ZM14 15.0003H9.99995V19.0003H14V15.0003ZM5 15.0003H9V19.0003H5V15.0003Z"
                fill="url(#paint1_linear_160_28744)"
            />
            <rect
                width={4}
                height={4}
                transform="matrix(1 0 0 -1 15 19.0002)"
                fill="url(#paint2_linear_160_28744)"
            />
            <g opacity="0.3">
                <path d="M5 10H9V14H5V10Z" fill="#AEB4BC" />
                <path d="M10 10.0002H14V14.0002H10V10.0002Z" fill="#AEB4BC" />
                <path
                    d="M19.0001 10.0002H15.0001V14.0002H19.0001V10.0002Z"
                    fill="#AEB4BC"
                />
                <path d="M14 15.0002H10V19.0002H14V15.0002Z" fill="#AEB4BC" />
                <path
                    d="M5.00005 15.0002H9.00005V19.0002H5.00005V15.0002Z"
                    fill="#AEB4BC"
                />
            </g>
            <path d="M15.75 17L17 15.75L18.25 17L17 18.25L15.75 17Z" fill="#76808F" />
            <path
                opacity="0.3"
                d="M9 22.5L9.75 23.25L10.5 22.5L9.75 21.75L9 22.5Z"
                fill="#AEB4BC"
            />
            <path
                opacity="0.3"
                d="M22.25 15.375L22.625 15.75L23 15.375L22.625 15L22.25 15.375Z"
                fill="#AEB4BC"
            />
            <rect
                opacity="0.3"
                x="1.5"
                y={10}
                width="0.5"
                height="0.5"
                fill="#AEB4BC"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28744"
                    x1={12}
                    y1="7.99998"
                    x2={12}
                    y2="3.99999"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_160_28744"
                    x1={3}
                    y1="9.91094"
                    x2={3}
                    y2="19.0891"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_160_28744"
                    x1={2}
                    y1={0}
                    x2={2}
                    y2={4}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="chart-pie-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.29047 5.04291C7.90004 3.72197 9.91782 3 12 3V12L18.364 5.63604C19.8363 7.10838 20.7526 9.04568 20.9567 11.1178C21.1526 13.1071 20.6805 15.1026 19.619 16.7907L13.4142 10.5859L12 12.0002L18.3639 18.3641C17.3237 19.4042 16.0375 20.1802 14.6126 20.6125C12.62 21.2169 10.4796 21.1117 8.55586 20.3149C6.63216 19.5181 5.04426 18.0789 4.06272 16.2426C3.08118 14.4062 2.76673 12.2864 3.17295 10.2442C3.57916 8.202 4.68091 6.36384 6.29047 5.04291Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="checkmark-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.0354 16.8122L7.03392 16.8137L9.15524 18.935L9.15672 18.9335L9.15685 18.9337L11.2782 16.8124L11.278 16.8122L20.4689 7.62132L18.3476 5.5L9.15672 14.6909L5.62132 11.1555L3.5 13.2768L7.0354 16.8122Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="close-f">
            <path
                d="M6.69806 4.57538L4.57674 6.6967L9.88004 12L4.57674 17.3033L6.69806 19.4246L12.0014 14.1213L17.3047 19.4246L19.426 17.3033L14.1227 12L19.426 6.6967L17.3047 4.57538L12.0014 9.87868L6.69806 4.57538Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="crypto-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM14.1642 18.5H12.5052V16.9617H11.4948V18.5H9.83585V16.9617H8.32773V7.03828H9.83585V5.5H11.4948V7.03828H12.5052V5.5H14.1642V7.08353C15.4611 7.29466 16.2152 8.2297 16.2152 9.58701C16.2152 10.9594 15.5969 11.5476 14.2848 11.7135V11.8039C15.6572 11.8794 16.5922 12.5731 16.5922 14.1265C16.5922 15.6497 15.5516 16.8863 14.1642 16.9617V18.5ZM13.0632 8.86311H10.4843V11.1102H13.0632C13.6363 11.1102 13.9832 10.8086 13.9832 10.2355V9.73782C13.9832 9.16473 13.6363 8.86311 13.0632 8.86311ZM13.4252 12.8596H10.4843V15.1369H13.4252C13.9983 15.1369 14.3602 14.8202 14.3602 14.2471V13.7494C14.3602 13.1763 13.9983 12.8596 13.4252 12.8596Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="deposit-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.5 3H10.5V9.94961L10.197 9.94695L6.03809 9.98779L12.0129 15.9626L17.9878 9.98779L13.8115 9.9787L13.5 9.97597V3ZM3.5 14H6.5V18H17.5V14H20.5V18V21H3.5V18V14Z"
                fill="#929AA5"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="diamond-outline-s24">
            <g>
                <path
                    d="M12.24 8L8 12.24l4.24 4.24 4.24-4.24L12.24 8zm-1.41 4.24l1.41-1.41 1.41 1.41-1.41 1.41-1.41-1.41z"
                    fill="currentColor"
                />
            </g>
        </symbol>
        <symbol viewBox="0 0 24 24" id="earn-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.63371 15.3239C3.95926 16.1426 4.40152 16.9023 4.93993 17.5823C6.58837 19.6643 9.13829 21 12.0001 21C16.9707 21 21.0001 16.9706 21.0001 12C21.0001 7.02944 16.9706 3 12 3C11.5568 3 11.1211 3.03203 10.6951 3.09391L11.0544 5.56795C11.3618 5.5233 11.6776 5.5 12.0001 5.5C12.0404 5.5 12.0806 5.50037 12.1206 5.50109C15.6549 5.56535 18.5001 8.45041 18.5001 12C18.5001 15.5899 15.59 18.5 12.0001 18.5C9.49239 18.5 7.31582 17.0802 6.2318 15.0003C6.13027 14.8057 6.0384 14.6054 5.95679 14.4002L3.63371 15.3239ZM3.09391 13.3049C3.03203 12.8789 3 12.4432 3 12C3 11.5568 3.03203 11.1211 3.09391 10.6951L5.56795 11.0544C5.5233 11.3618 5.5 11.6774 5.5 12C5.5 12.3226 5.5233 12.6382 5.56795 12.9456L3.09391 13.3049ZM5.95679 9.59984L3.63371 8.67609C3.95926 7.85737 4.40152 7.09773 4.93993 6.41771L6.89996 7.96958C6.51034 8.46168 6.19125 9.01019 5.95679 9.59984ZM6.41771 4.93993L7.96958 6.89996C8.46168 6.51034 9.01019 6.19125 9.59984 5.95679L8.67609 3.63371C7.85737 3.95926 7.09773 4.40152 6.41771 4.93993ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12ZM13.6 12L12 13.6L10.4 12L12 10.4L13.6 12Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="earn-s24">
            <path
                d="M11.3363 8.57657C10.5672 8.72738 10.2354 9.13457 10.2354 9.72274C10.2354 10.2958 10.5672 10.5974 11.3363 10.8086V8.57657Z"
                fill="currentColor"
            />
            <path
                d="M12.6785 15.3933C13.3873 15.1972 13.7191 14.7297 13.7191 14.1566C13.7191 13.7193 13.5382 13.2668 12.6785 13.0104V15.3933Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.8595 17.0522V18.5H11.1402V17.1125C9.61705 16.9768 8.60661 16.3585 7.85255 15.529L9.20985 14.2923C9.78294 14.8956 10.4918 15.3028 11.3363 15.4234V12.7088C9.07412 12.2413 8.15417 11.2459 8.15417 9.78306C8.15417 8.19954 9.19477 7.14385 11.1402 6.91763V5.5H12.8595V6.91763C14.066 7.05336 14.9558 7.52088 15.6194 8.27494L14.247 9.5116C13.885 9.10441 13.4024 8.77262 12.6785 8.60673V11.1102C14.7899 11.5928 15.8003 12.4524 15.8003 13.9907C15.8003 15.4687 14.8653 16.7204 12.8595 17.0522Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="ethoptions-g">
            <path
                opacity="0.3"
                d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22L12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4L12 2Z"
                fill="#AEB4BC"
            />
            <path
                d="M2 12C2 6.47715 6.47715 2 12 2V4C7.58172 4 4 7.58172 4 12C4 14.2094 4.89434 16.208 6.34315 17.6569L7.75 16.25V20.5H3.5L4.92893 19.0711C3.12038 17.2625 2 14.7611 2 12Z"
                fill="url(#paint0_linear_160_28529)"
            />
            <circle cx={12} cy={12} r={5} fill="#687EE3" />
            <path d="M12 13.7682V15.5096L14.1434 12.5L12 13.7682Z" fill="#D2D8EC" />
            <path d="M12 11.0809V13.3225L14.1434 12.0544L12 11.0809Z" fill="#C4C8D8" />
            <path d="M12 8.5V11.081L14.1434 12.0544L12 8.5Z" fill="#D0D6EA" />
            <path
                d="M11.9998 13.7682V15.5096L9.85645 12.5L11.9998 13.7682Z"
                fill="#DEE2F6"
            />
            <path
                d="M11.9998 11.0809V13.3225L9.85645 12.0544L11.9998 11.0809Z"
                fill="#D2D8EC"
            />
            <path d="M11.9998 8.5V11.081L9.85645 12.0544L11.9998 8.5Z" fill="#DEE2F6" />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28529"
                    x1={7}
                    y1={2}
                    x2={7}
                    y2="20.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 25" id="feed-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.99976 3.5H21.0001V19.5H10.9998L6.99976 23.5V19.5H2.99976V3.5ZM8.2224 8.16968C12.365 8.16968 15.7233 11.528 15.7233 15.6706L17.7233 15.6706C17.7233 10.4234 13.4696 6.16968 8.2224 6.16968V8.16968ZM11.7224 15.6706C11.7224 13.7376 10.1554 12.1706 8.2224 12.1706V10.1706C11.26 10.1706 13.7224 12.6331 13.7224 15.6706L11.7224 15.6706ZM8.22229 17.1708C9.05072 17.1708 9.72229 16.4993 9.72229 15.6708C9.72229 14.8424 9.05072 14.1708 8.22229 14.1708C7.39386 14.1708 6.72229 14.8424 6.72229 15.6708C6.72229 16.4993 7.39386 17.1708 8.22229 17.1708Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="feed-g">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.00037 2H22.0005V17.9998H11.5407L7.04053 22.5V17.9998H2.00037V2ZM8.54063 6.86475C12.6833 6.86475 16.0416 10.223 16.0416 14.3657L18.0416 14.3657C18.0416 9.11846 13.7879 4.86475 8.54063 4.86475V6.86475ZM12.0406 14.3657C12.0406 12.4327 10.4736 10.8657 8.54063 10.8657V8.8657C11.5782 8.8657 14.0406 11.3281 14.0406 14.3657L12.0406 14.3657ZM8.54053 15.8659C9.36895 15.8659 10.0405 15.1943 10.0405 14.3659C10.0405 13.5375 9.36895 12.8659 8.54053 12.8659C7.7121 12.8659 7.04053 13.5375 7.04053 14.3659C7.04053 15.1943 7.7121 15.8659 8.54053 15.8659Z"
                fill="url(#paint0_linear_52508_22402)"
            />
            <path
                d="M8.54063 6.86475C12.6833 6.86475 16.0416 10.223 16.0416 14.3657L18.0416 14.3657C18.0416 9.11846 13.7879 4.86475 8.54063 4.86475L8.54063 6.86475Z"
                fill="#76808F"
            />
            <path
                d="M12.0406 14.3657C12.0406 12.4327 10.4736 10.8657 8.54063 10.8657L8.54063 8.8657C11.5782 8.8657 14.0406 11.3281 14.0406 14.3657L12.0406 14.3657Z"
                fill="#76808F"
            />
            <path
                d="M10.0405 14.3659C10.0405 15.1943 9.36895 15.8659 8.54053 15.8659C7.7121 15.8659 7.04053 15.1943 7.04053 14.3659C7.04053 13.5375 7.7121 12.8659 8.54053 12.8659C9.36895 12.8659 10.0405 13.5375 10.0405 14.3659Z"
                fill="#76808F"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_52508_22402"
                    x1="12.0005"
                    y1={2}
                    x2="12.0005"
                    y2="22.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="gift-f">
            <path
                d="M13.5 6.37868V3H10.5V6.37868L7.56065 3.43934L5.43933 5.56066L7.87867 8H4V11H10.75V8H13.25V11L20 11V8H16.1213L18.5607 5.56066L16.4393 3.43934L13.5 6.37868Z"
                fill="currentColor"
            />
            <path d="M4 13.5V20H10.75V13.5H4Z" fill="currentColor" />
            <path d="M13.25 20H20V13.5H13.25V20Z" fill="currentColor" />
        </symbol>
        <symbol viewBox="0 0 6307 1024" id="icon-binance-4th">
            <path
                d="M659.41504 74.79296h-147.78368v936.3456h147.78368V74.79296zM255.83616 340.1728h147.78368v422.7072H255.83616V340.13184z m616.12032 214.13888l-104.52992 104.57088 104.52992 104.57088 104.52992-104.57088-104.52992-104.57088z m-724.1728 60.70272H0v147.82464h147.78368v-147.8656z"
                fill="currentColor"
            />
            <path
                d="M1847.82848 541.98272L1742.68416 647.168l-106.04544-105.18528 106.0864-106.0864 105.10336 106.0864z m256.86016-256.94208l181.00224 181.0432 106.04544-106.0864-287.04768-286.18752-287.04768 287.1296 106.0864 106.0864 180.96128-181.98528z m362.00448 150.89664l-105.14432 106.0864 106.0864 106.04544 106.00448-106.0864-106.94656-106.0864z m-362.00448 363.02848l-181.00224-181.98528-106.04544 106.0864 287.04768 287.1296 287.04768-287.1296-106.0864-106.0864-180.96128 181.98528z m0-151.79776l106.04544-106.0864-106.04544-105.14432-106.04544 106.0864 106.04544 105.14432z m1115.25888 10.97728v-1.8432c0-68.56704-36.57728-103.34208-96.01024-126.1568 36.57728-20.15232 67.66592-53.08416 67.66592-110.67392v-1.8432c0-80.44544-64.9216-132.58752-169.12384-132.58752h-238.592v512.98304h244.08064c116.08064 0.94208 191.97952-46.61248 191.97952-139.8784z m-140.77952-219.46368c0 38.37952-31.08864 53.94432-81.34656 53.94432h-104.2432V383.7952h111.53408c47.5136 0 74.05568 19.2512 74.05568 53.0432v1.8432z m28.34432 204.8c0 38.42048-30.18752 55.78752-79.54432 55.78752h-134.3488v-112.47616h130.6624c57.63072 0 83.23072 21.05344 83.23072 55.78752v0.90112z m349.184 155.48416V285.04064h-113.33632v512.98304h113.33632v0.94208z m607.0272 0V285.04064h-111.57504v316.416l-240.4352-316.416h-104.16128v512.98304h111.49312v-325.50912l248.6272 326.4512h96.01024z m625.2544 0l-220.32384-516.66944h-104.20224l-220.32384 516.66944h116.1216l46.61248-115.22048h216.63744l46.61248 115.22048h118.86592z m-205.70112-214.91712h-136.192l68.56704-166.42048 67.62496 166.42048z m744.12032 214.91712V285.04064h-111.53408v316.416l-240.4352-316.416h-104.20224v512.98304h111.53408v-325.50912l248.6272 326.4512h96.01024z m582.28736-83.23072l-72.21248-72.25344c-40.22272 36.57728-75.85792 60.37504-135.29088 60.37504-87.73632 0-149.01248-73.15456-149.01248-160.9728v-2.70336c0-87.77728 62.17728-160.03072 149.01248-160.03072 51.2 0 91.42272 21.95456 131.64544 57.58976l72.21248-83.18976c-47.55456-46.65344-105.14432-79.54432-202.01472-79.54432-157.24544 0-267.83744 119.76704-267.83744 265.17504v1.80224c0 147.2512 112.4352 264.27392 263.24992 264.27392 98.7136 0.90112 157.24544-33.83296 210.24768-90.5216z m481.77152 83.23072V698.368h-278.81472v-107.88864h242.23744V489.8816h-242.23744V385.6384h275.12832V285.04064h-386.6624v512.98304h390.3488v0.94208z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-coinmarketcap">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.392 13.9478C19.0378 14.173 18.6265 14.1955 18.3066 14.0154C17.9068 13.7902 17.6783 13.2724 17.6783 12.5407V10.368C17.6783 9.30985 17.2556 8.56687 16.5473 8.36424C15.3477 8.01527 14.4452 9.46745 14.1139 10.0078L12.0003 13.385V9.25356C11.9775 8.30795 11.6576 7.73383 11.0635 7.56498C10.6751 7.4524 10.081 7.49743 9.50979 8.35298L4.78005 15.8503C4.15171 14.6683 3.8204 13.3399 3.8204 12.0003C3.8204 7.48618 7.48766 3.81632 12.0003 3.81632C16.513 3.81632 20.1802 7.48618 20.1802 12.0003C20.1802 12.0116 20.1802 12.0116 20.1802 12.0228C20.1802 12.0341 20.1802 12.0341 20.1802 12.0454C20.2145 12.9234 19.9289 13.6101 19.392 13.9478ZM21.9967 12.0003V11.9778V11.9553C21.9625 6.46177 17.4955 2.00391 12.0003 2.00391C6.4823 2.00391 2.00391 6.48428 2.00391 12.0003C2.00391 17.5164 6.4823 21.9967 12.0003 21.9967C14.5251 21.9967 16.9471 21.0511 18.7979 19.3288C19.1635 18.9911 19.1863 18.4169 18.8436 18.0455C18.5123 17.6852 17.9411 17.6515 17.5755 17.9892L17.564 18.0004C16.0674 19.3963 14.0682 20.1843 12.0003 20.1843C9.58976 20.1843 7.41911 19.1261 5.91108 17.4601L10.1838 10.7057V13.824C10.1838 15.3212 10.7779 15.8053 11.2692 15.9404C11.7604 16.0867 12.5144 15.9854 13.3141 14.7133L15.6562 10.9647C15.7361 10.8408 15.8047 10.7395 15.8618 10.6495V12.5407C15.8618 13.9366 16.433 15.051 17.4155 15.6026C18.3066 16.098 19.4262 16.0529 20.3402 15.4901C21.4598 14.8034 22.0539 13.5313 21.9967 12.0003Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-discord">
            <path
                d="M8.81861 12.4809C8.81861 13.1691 9.32333 13.7307 9.94218 13.7307C10.567 13.7307 11.0657 13.1689 11.0657 12.4809C11.0783 11.7927 10.5666 11.2311 9.94218 11.2311C9.31104 11.2311 8.81861 11.7929 8.81861 12.4809Z"
                fill="currentColor"
            />
            <path
                d="M12.9657 12.4809C12.9657 13.1691 13.4717 13.7307 14.0898 13.7307C14.7209 13.7307 15.2134 13.1689 15.2134 12.4809C15.226 11.7927 14.7142 11.2311 14.0898 11.2311C13.4588 11.2311 12.9657 11.7929 12.9657 12.4809Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.7742 7.27979C14.6769 7.43114 15.5417 7.70285 16.3559 8.07514H16.3582C17.7718 10.1392 18.4738 12.4746 18.2021 15.1636C17.122 15.9526 16.0679 16.4322 15.039 16.7479C14.7862 16.4071 14.5592 16.0408 14.3636 15.6559C14.736 15.5169 15.0901 15.3465 15.4302 15.1446C15.3634 15.0969 15.2993 15.0455 15.2338 14.9929C15.2131 14.9763 15.1923 14.9595 15.1711 14.9428C13.1385 15.8833 10.9098 15.8833 8.852 14.9428C8.76888 15.0119 8.68087 15.0818 8.59287 15.1446C8.93365 15.3465 9.28729 15.5169 9.65958 15.6559C9.464 16.0409 9.237 16.4071 8.98415 16.7479C7.95467 16.4323 6.90681 15.9526 5.82103 15.1636C5.60017 12.8407 6.04203 10.4864 7.67688 8.07514C8.48544 7.70236 9.35015 7.43135 10.2591 7.27979C10.3652 7.47536 10.4987 7.74078 10.5867 7.94893C11.5334 7.80993 12.4867 7.80993 13.4466 7.94893C13.5347 7.74078 13.6604 7.47536 13.7742 7.27979Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-dropdown-arrow">
            <path
                d="M16.5 8.49023V10.7402L12 15.5102L7.5 10.7402V8.49023H16.5Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-facebook">
            <path
                d="M22 12.0698C22 17.0832 18.3413 21.2485 13.5627 22.0107V14.9791H15.8987L16.336 12.0698H13.5733V10.1804C13.5733 9.38594 13.9573 8.60225 15.1947 8.60225H16.464V6.13312C16.464 6.13312 15.312 5.93988 14.224 5.93988C11.9413 5.93988 10.4373 7.33548 10.4373 9.84756V12.0698H7.89867V14.9791H10.4373V22.0107C5.65867 21.2378 2 17.0832 2 12.0698C2 6.50886 6.48 2 12.0053 2C17.5307 2 22 6.50886 22 12.0698Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-future-s">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5 3H20V16C20 18.2091 18.2091 20 16 20H7.5C5.567 20 4 18.433 4 16.5V9H8.5V3ZM11 14.5056V17.0056L17.5 17.0056V14.5056H11ZM8.5 11.5H6.5V16.5C6.5 17.0523 6.94772 17.5 7.5 17.5C8.05228 17.5 8.5 17.0523 8.5 16.5V11.5ZM12.5001 6.00562H17.5001V11.0056L15.8846 9.3901L13.2691 12.0056L11.5013 10.2379L14.1168 7.62233L12.5001 6.00562Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 4010 1024" id="icon-h-futures">
            <path d="M1443.84 511.573333h-188.416V115.370667h184.32c81.237333 0 130.773333 40.576 130.773333 102.314666v1.621334c0 44.672-23.552 69.845333-51.968 85.248 45.482667 17.877333 73.898667 43.861333 73.898667 97.450666v0.853334c-0.853333 73.045333-59.306667 108.8-148.608 108.8z m38.954667-279.338666c0-25.984-20.266667-40.576-56.832-40.576h-86.058667v83.626666h80.384c38.144 0 62.506667-12.16 62.506667-42.24v-0.810666z m22.741333 159.146666c0-26.752-19.456-43.008-64.128-43.008h-101.546667V435.2h103.978667c38.144 0 61.696-13.781333 61.696-43.008v-0.853333z m181.930667 120.234667V115.328h86.869333v396.288H1687.466667z m481.536 0l-191.658667-251.733333v251.733333h-86.058667V115.328h80.384l185.941334 244.394667V115.328h86.101333v396.288h-74.709333z m466.133333 0l-36.565333-88.533333h-167.253334l-35.754666 88.533333h-89.344l169.728-399.573333h80.384l170.538666 399.573333h-91.733333zM2514.944 217.6l-52.778667 128.298667h105.557334L2514.944 217.6z m552.96 293.973333l-191.573333-251.733333v251.733333h-86.101334V115.328h80.384l185.941334 244.394667V115.328h86.101333v396.288h-74.709333z m362.24 7.253334c-116.949333 0-203.050667-90.112-203.050667-203.776v-0.853334c0-112.853333 85.290667-204.629333 207.061334-204.629333 74.752 0 119.381333 25.173333 155.946666 60.928L3534.890667 234.666667c-30.890667-27.605333-61.738667-44.629333-101.546667-44.629334-66.56 0-115.285333 55.210667-115.285333 123.434667v0.810667c0 68.181333 47.104 124.245333 115.328 124.245333 45.44 0 73.045333-17.92 103.936-46.293333l55.210666 56.021333c-40.618667 43.050667-86.101333 70.656-162.432 70.656z m232.234667-7.253334V115.328h298.837333V193.28h-211.968v80.384h186.794667v77.952h-186.794667v83.626667h215.210667v76.373333h-302.08z m-1447.893334 160.768h-159.146666v76.330667h141.269333v44.672h-141.312v114.474667h-49.493333v-280.96h208.64v45.482666z m301.226667 113.706667c0 83.626667-47.061333 125.866667-120.96 125.866667-73.088 0-119.381333-42.24-119.381333-123.434667v-161.621333h49.536v159.146666c0 52.010667 26.794667 80.426667 70.656 80.426667s70.656-26.794667 70.656-77.952v-161.621333h49.493333v159.146666z m198.997333 121.770667h-49.536v-234.666667H2575.786667v-45.482667h227.413333v45.482667h-89.344v234.666667h0.810667z m388.949334-121.770667c0 83.626667-47.104 125.866667-121.002667 125.866667-73.088 0-119.338667-42.24-119.338667-123.434667v-161.621333h49.493334v159.146666c0 52.010667 26.837333 80.426667 70.656 80.426667 43.861333 0 70.656-26.794667 70.656-77.952v-161.621333h49.536v159.146666z m265.557333 121.770667l-69.034667-97.450667h-61.696v97.450667H3188.906667v-280.96h125.013333c64.170667 0 103.978667 34.133333 103.978667 89.344 0 46.293333-27.605333 74.666667-66.56 85.248l75.52 106.368h-57.685334z m-58.453333-235.52H3239.253333v94.250666h72.277334c34.901333 0 57.6-18.688 57.6-47.104-0.768-30.848-21.888-47.104-58.453334-47.104z m392.192-0.768h-158.336v73.088h140.501333v43.861333h-140.501333v75.52h160.768v43.818667h-210.346667v-280.96h207.914667v44.672z m185.173333 73.898666c59.306667 14.592 90.112 35.712 90.112 82.816 0 52.778667-41.386667 84.48-99.84 84.48a171.477333 171.477333 0 0 1-116.949333-44.672l30.037333-34.944c26.794667 23.552 53.589333 36.565333 88.490667 36.565334 30.890667 0 49.536-13.824 49.536-35.754667 0-20.266667-11.349333-31.658667-63.317334-43.008-60.117333-14.634667-93.397333-31.701333-93.397333-84.48 0-48.725333 39.808-82.005333 95.829333-82.005333 40.576 0 73.088 12.202667 101.504 34.901333l-26.794666 37.376c-25.173333-18.688-50.346667-29.226667-76.373334-29.226667-29.184 0-45.44 14.592-45.44 33.28 0.810667 21.930667 13.013333 31.658667 66.56 44.672z m-2063.445333-0.853333h-570.026667v47.146667h570.026667v-47.104zM115.328 396.330667L0 511.573333l115.328 115.285334 116.096-115.285334-116.096-115.328z m396.288-164.864l198.101333 198.144 115.328-115.285334-197.333333-198.954666L511.616 0 396.288 115.328 198.144 313.472l115.328 115.285333 198.144-197.333333z m396.245333 164.864l-115.285333 115.328 115.285333 115.285333L1024 511.616l-116.138667-115.328z m-396.245333 396.288l-198.144-198.144-115.328 115.285333 198.144 198.144L511.573333 1024l115.285334-115.328 198.144-198.101333-115.328-116.138667-198.101334 198.144z m0-164.864l116.096-116.096-116.096-115.328-115.328 115.328 115.328 116.096z" />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-instagram">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0001 7.38184C9.44926 7.38184 7.38184 9.44926 7.38184 12.0001C7.38184 14.551 9.44926 16.6184 12.0001 16.6184C14.551 16.6184 16.6184 14.551 16.6184 12.0001C16.6184 9.44926 14.551 7.38184 12.0001 7.38184ZM12.0001 15.0036C10.3441 15.0036 8.99669 13.6561 8.99669 12.0001C8.99669 10.3441 10.3441 8.99669 12.0001 8.99669C13.6561 8.99669 15.0036 10.3441 15.0036 12.0001C15.0036 13.6561 13.6561 15.0036 12.0001 15.0036Z"
                fill="currentColor"
            />
            <path
                d="M17.8836 7.1967C17.8836 7.79317 17.4001 8.2767 16.8036 8.2767C16.2072 8.2767 15.7236 7.79317 15.7236 7.1967C15.7236 6.60023 16.2072 6.1167 16.8036 6.1167C17.4001 6.1167 17.8836 6.60023 17.8836 7.1967Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3C9.552 3 9.25371 3.01029 8.28686 3.05143C7.33029 3.10286 6.672 3.24686 6.10629 3.47314C5.50971 3.69943 5.016 4.008 4.512 4.512C4.008 5.016 3.69943 5.50971 3.47314 6.10629C3.24686 6.672 3.10286 7.33029 3.05143 8.28686C3.01029 9.25371 3 9.552 3 12C3 14.448 3.01029 14.7463 3.05143 15.7131C3.09257 16.6697 3.24686 17.328 3.47314 17.8937C3.69943 18.4903 4.008 18.984 4.512 19.488C5.016 19.992 5.50971 20.3006 6.10629 20.5269C6.68229 20.7531 7.33029 20.8971 8.28686 20.9486C9.24343 20.9897 9.552 21 12 21C14.448 21 14.7463 20.9897 15.7131 20.9486C16.6697 20.9074 17.328 20.7531 17.8937 20.5269C18.4903 20.3006 18.984 19.992 19.488 19.488C19.992 18.984 20.3006 18.4903 20.5269 17.8937C20.7531 17.3177 20.8971 16.6697 20.9486 15.7131C20.9897 14.7566 21 14.448 21 12C21 9.552 20.9897 9.25371 20.9486 8.28686C20.9074 7.33029 20.7531 6.672 20.5269 6.10629C20.3006 5.50971 19.992 5.016 19.488 4.512C18.984 4.008 18.4903 3.69943 17.8937 3.47314C17.3177 3.24686 16.6697 3.10286 15.7131 3.05143C14.7463 3.01029 14.448 3 12 3ZM12 4.62514C14.4069 4.62514 14.6846 4.63543 15.6411 4.67657C16.5154 4.71771 16.9989 4.86171 17.3074 4.98514C17.7291 5.14971 18.0274 5.34514 18.3463 5.65371C18.6651 5.97257 18.8606 6.27086 19.0149 6.69257C19.1383 7.01143 19.2823 7.48457 19.3234 8.35886C19.3646 9.30514 19.3749 9.59314 19.3749 12C19.3749 14.4069 19.3646 14.6846 19.3234 15.6411C19.2823 16.5154 19.1383 16.9989 19.0149 17.3074C18.8503 17.7291 18.6549 18.0274 18.3463 18.3463C18.0274 18.6651 17.7291 18.8606 17.3074 19.0149C16.9886 19.1383 16.5154 19.2823 15.6411 19.3234C14.6949 19.3646 14.4069 19.3749 12 19.3749C9.59314 19.3749 9.31543 19.3646 8.35886 19.3234C7.48457 19.2823 7.00114 19.1383 6.69257 19.0149C6.27086 18.8503 5.97257 18.6549 5.65371 18.3463C5.33486 18.0274 5.13943 17.7291 4.98514 17.3074C4.86171 16.9886 4.71771 16.5154 4.67657 15.6411C4.63543 14.6949 4.62514 14.4069 4.62514 12C4.62514 9.59314 4.63543 9.31543 4.67657 8.35886C4.71771 7.48457 4.86171 7.00114 4.98514 6.69257C5.14971 6.27086 5.34514 5.97257 5.65371 5.65371C5.97257 5.33486 6.27086 5.13943 6.69257 4.98514C7.01143 4.86171 7.48457 4.71771 8.35886 4.67657C9.31543 4.63543 9.59314 4.62514 12 4.62514Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-linkedin">
            <path
                d="M19.6629 3H4.32686C3.59657 3 3 3.58629 3 4.30629V19.704C3 20.424 3.59657 21 4.32686 21H19.6629C20.4034 21 21 20.424 21 19.704V4.30629C21 3.58629 20.4034 3 19.6629 3ZM8.33829 18.3463H5.664V9.75771H8.33829V18.3463ZM7.00114 8.57486C6.14743 8.57486 5.45829 7.88571 5.45829 7.032C5.45829 6.17829 6.14743 5.47886 7.00114 5.47886C7.85486 5.47886 8.55429 6.17829 8.55429 7.032C8.55429 7.88571 7.85486 8.57486 7.00114 8.57486ZM18.336 18.3463H15.672V14.1703C15.672 13.1726 15.6514 11.8869 14.2834 11.8869C12.8949 11.8869 12.6789 12.9771 12.6789 14.0983V18.3463H10.0149V9.75771H12.576V10.9303H12.6069C12.9669 10.2514 13.8411 9.54171 15.1371 9.54171C17.8423 9.54171 18.336 11.3211 18.336 13.6354V18.3463Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-market">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.5 4H14.5V19H9.5V4ZM3 11H7.5V19H3V11ZM21 9H16.5V19H21V9Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-medium">
            <path
                d="M3 3V21H21V3H3ZM17.9519 7.26316L16.984 8.18993C16.9016 8.25172 16.8604 8.35469 16.881 8.45767V15.2643C16.8604 15.3673 16.9016 15.4703 16.984 15.532L17.9314 16.4588V16.6648H13.1842V16.4588L14.1625 15.5114C14.2654 15.4188 14.2654 15.3879 14.2654 15.2437V9.74485L11.5469 16.6339H11.1762L8.01487 9.74485V14.3684C7.99428 14.5538 8.05606 14.7494 8.18993 14.8936L9.46682 16.4382V16.6339H5.8627V16.4382L7.12929 14.8936C7.26316 14.7494 7.32494 14.5538 7.29405 14.3684V9.02403C7.31465 8.86957 7.25286 8.7254 7.13959 8.62243L6.01716 7.26316V7.05721H9.51831L12.2265 13.0092L14.6053 7.05721H17.9519V7.26316Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-reddit">
            <path
                d="M9.71176 11.9941C10.2872 11.9941 10.756 12.463 10.756 13.0384C10.756 13.6138 10.2872 14.0827 9.71176 14.0827C9.13634 14.0827 8.66748 13.6138 8.66748 13.0384C8.66748 12.463 9.13634 11.9941 9.71176 11.9941Z"
                fill="currentColor"
            />
            <path
                d="M12.0028 16.0217C12.6847 16.0217 13.6438 15.8619 14.0913 15.4143C14.1979 15.3078 14.3684 15.3078 14.4749 15.4037C14.5815 15.5102 14.5815 15.6807 14.4749 15.7873C13.761 16.5012 12.4077 16.5545 12.0028 16.5545C11.5978 16.5545 10.2445 16.5012 9.5306 15.7979C9.42404 15.6914 9.42404 15.5209 9.5306 15.4143C9.63716 15.3078 9.80766 15.3078 9.91421 15.4143C10.3618 15.8619 11.3208 16.0217 12.0028 16.0217Z"
                fill="currentColor"
            />
            <path
                d="M13.2495 13.0492C13.2495 12.4737 13.7184 12.0049 14.2938 12.0049C14.8585 12.0049 15.3274 12.4737 15.3381 13.0492C15.3381 13.6246 14.8692 14.0934 14.2938 14.0934C13.7184 14.0934 13.2495 13.6246 13.2495 13.0492Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.003 2.00977C6.48328 2.00977 2.00781 6.48523 2.00781 12.005C2.00781 17.5247 6.48328 22.0002 12.003 22.0002C17.5227 22.0002 21.9982 17.5354 21.9982 12.005C21.9876 6.48523 17.5227 2.00977 12.003 2.00977ZM17.7998 13.3369C17.8211 13.4755 17.8318 13.6247 17.8318 13.7738C17.8318 16.0222 15.2211 17.8337 12.003 17.8337C8.78494 17.8337 6.17426 16.0222 6.17426 13.7738C6.17426 13.6247 6.18491 13.4755 6.20622 13.3369C5.69474 13.1132 5.3431 12.6017 5.3431 12.005C5.3431 11.2058 5.99311 10.5451 6.80295 10.5451C7.19722 10.5451 7.54886 10.6943 7.81526 10.95C8.82756 10.2148 10.2235 9.75658 11.7792 9.71395C11.7792 9.69264 12.5145 6.22949 12.5145 6.22949C12.5145 6.16555 12.5571 6.10162 12.6104 6.06965C12.6637 6.02703 12.7383 6.01637 12.8129 6.02703L15.2317 6.54916C15.4022 6.20818 15.7539 5.96309 16.1588 5.96309C16.7342 5.96309 17.2031 6.42129 17.2031 7.00737C17.2031 7.59344 16.7342 8.05164 16.1588 8.05164C15.6047 8.05164 15.1465 7.61475 15.1252 7.06064L12.9514 6.59179L12.2907 9.71395C13.8252 9.76723 15.1998 10.2361 16.1908 10.95C16.4572 10.6943 16.8088 10.5345 17.2031 10.5345C18.0129 10.5345 18.6629 11.1845 18.6629 11.9943C18.6629 12.6017 18.3006 13.1025 17.7998 13.3369Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-steemit">
            <path
                d="M18.8494 8.4353C18.0917 7.69356 17.1973 7.14755 16.2397 6.78699C16.7974 5.20048 18.7862 4.61327 18.7862 4.61327C18.7862 4.61327 14.2193 2.28502 9.1788 3.2225C7.49513 3.48005 5.8746 4.47934 4.71708 5.8186C2.16001 8.70315 2.49674 13.0712 5.47473 15.5437C5.93774 15.9248 6.95846 16.5121 6.95846 16.543C6.30604 18.2325 4.14884 18.6858 4.14884 18.6858C4.14884 18.6858 7.00055 20.4371 10.7993 20.8904C11.8306 21.014 12.8934 21.0449 13.9878 20.9213C15.7346 20.7874 17.4919 19.8499 18.8494 18.5828C21.7011 15.8012 21.7326 11.258 18.8494 8.4353ZM17.555 17.4804C16.4712 18.5209 14.8822 19.17 13.6195 19.2627C12.725 19.3657 11.799 19.3657 10.9046 19.2627C9.57867 19.1082 8.62108 18.7476 7.66349 18.387C8.1265 17.9337 8.62108 17.3259 8.82102 16.7696C8.94729 16.4502 8.91572 16.0897 8.78945 15.8012C7.7582 13.7511 8.22121 11.3199 9.87331 9.73335C11.0729 8.56923 12.725 8.05413 14.4087 8.24987C15.6399 8.4044 16.7658 8.9298 17.6603 9.76426C19.7754 11.8762 19.7122 15.4097 17.555 17.4804Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-telegram">
            <path
                d="M12 2C6.47761 2 2 6.47761 2 11.9893C2 17.5117 6.47761 22 12 22C17.5224 22 22 17.5117 22 11.9893C22 6.47761 17.5224 2 12 2ZM16.9254 8.27932C16.8614 9.20682 15.145 16.1365 15.145 16.1365C15.145 16.1365 15.0384 16.5416 14.6652 16.5522C14.5373 16.5522 14.3667 16.5416 14.1748 16.3603C13.7804 16.0299 12.8849 15.3902 12.0426 14.8038C12.0107 14.8358 11.9787 14.8678 11.936 14.8998C11.7441 15.0704 11.4563 15.3156 11.1471 15.6141C11.0299 15.7207 10.9019 15.838 10.774 15.9659L10.7633 15.9765C10.6887 16.0512 10.6247 16.1045 10.5714 16.1471C10.1557 16.4883 10.113 16.2004 10.113 16.0512L10.3369 13.6098V13.5885L10.3475 13.5672C10.3582 13.5352 10.3795 13.5245 10.3795 13.5245C10.3795 13.5245 14.7399 9.64392 14.8571 9.22815C14.8678 9.20682 14.8358 9.1855 14.7825 9.20682C14.4947 9.30277 9.47335 12.4797 8.91898 12.8316C8.88699 12.8529 8.79104 12.8422 8.79104 12.8422L6.34968 12.0426C6.34968 12.0426 6.06183 11.9254 6.15778 11.6588C6.1791 11.6055 6.21109 11.5522 6.32836 11.4776C6.87207 11.0938 16.3284 7.69296 16.3284 7.69296C16.3284 7.69296 16.5949 7.60768 16.7548 7.66098C16.8294 7.69296 16.8721 7.72495 16.9147 7.83156C16.9254 7.8742 16.936 7.95949 16.936 8.05544C16.936 8.10874 16.9254 8.17271 16.9254 8.27932Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-tiktok">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5168 3C15.8138 5.55428 17.2395 7.07713 19.7181 7.23914V10.112C18.2817 10.2524 17.0234 9.78262 15.56 8.89699V14.2702C15.56 21.096 8.11856 23.2291 5.12686 18.3365C3.2044 15.1882 4.38164 9.66382 10.5486 9.44241V12.4719C10.0788 12.5475 9.5766 12.6663 9.11759 12.8229C7.74594 13.2873 6.96832 14.1568 7.18433 15.6904C7.60014 18.6281 12.9895 19.4975 12.5413 13.7571V3.0054H15.5168V3Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-top-menu-s">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 4H8V8H4V4ZM4 10H8V14H4V10ZM8 16H4V20H8V16ZM10 4H14V8H10V4ZM14 10H10V14H14V10ZM10 16H14V20H10V16ZM20 4H16V8H20V4ZM16 10H20V14H16V10ZM20 16H16V20H20V16Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-twitter">
            <path
                d="M8.28726 20.5C15.832 20.5 19.9621 13.965 19.9621 8.30213C19.9621 8.12092 19.9621 7.93971 19.9512 7.74717C20.7534 7.1469 21.4472 6.38807 22 5.52732C21.2629 5.86709 20.4715 6.0936 19.6369 6.20686C20.4824 5.67455 21.1328 4.83644 21.4472 3.82845C20.6558 4.32678 19.7778 4.67788 18.8347 4.87042C18.0867 4.02099 17.0244 3.5 15.8428 3.5C13.5772 3.5 11.7344 5.42538 11.7344 7.79247C11.7344 8.13225 11.7778 8.44937 11.8428 8.76649C8.43902 8.5966 5.41463 6.87508 3.38753 4.28148C3.02981 4.92705 2.83469 5.66322 2.83469 6.4447C2.83469 7.92838 3.56098 9.24217 4.65583 10.0123C3.98374 9.98967 3.35501 9.79714 2.80217 9.48001C2.80217 9.49134 2.80217 9.51399 2.80217 9.53664C2.80217 11.6093 4.22222 13.3534 6.08672 13.7385C5.73984 13.8404 5.38211 13.8857 5.00271 13.8857C4.74255 13.8857 4.48238 13.8631 4.23306 13.8065C4.75339 15.5167 6.271 16.7512 8.07046 16.7851C6.66125 17.9404 4.89431 18.6199 2.97561 18.6199C2.65041 18.6199 2.31436 18.6086 2 18.5633C3.8103 19.7865 5.96748 20.5 8.28726 20.5Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-vk">
            <path
                d="M12 2C6.47761 2 2 6.47761 2 12C2 17.5224 6.47761 22 12 22C17.5224 22 22 17.5224 22 12C22 6.47761 17.5117 2 12 2ZM18.1407 16.2644H16.6908C16.1365 16.2644 15.9765 15.8166 14.9851 14.8252C14.1215 13.9936 13.7484 13.8763 13.5352 13.8763C13.2367 13.8763 13.1514 13.951 13.1514 14.3667V15.678C13.1514 16.0299 13.0341 16.2431 12.1066 16.2431C10.5714 16.2431 8.86567 15.3156 7.66098 13.5778C5.84861 11.0405 5.35821 9.12154 5.35821 8.73774C5.35821 8.52452 5.43284 8.33262 5.84861 8.33262H7.31983C7.6823 8.33262 7.83156 8.49254 7.97015 8.89765C8.68443 10.9765 9.88913 12.7889 10.3795 12.7889C10.5608 12.7889 10.6461 12.7036 10.6461 12.2345V10.1023C10.5928 9.11087 10.0704 9.02559 10.0704 8.67377C10.0704 8.5032 10.209 8.33262 10.4328 8.33262H12.7143C13.0235 8.33262 13.1407 8.5032 13.1407 8.86567V11.7548C13.1407 12.064 13.2687 12.1812 13.3646 12.1812C13.5458 12.1812 13.7058 12.064 14.0469 11.7335C15.0917 10.5608 15.838 8.75906 15.838 8.75906C15.9339 8.54584 16.1045 8.35394 16.4776 8.35394H17.9275C18.3646 8.35394 18.4606 8.57783 18.3646 8.88699C18.1834 9.72921 16.4136 12.2239 16.4136 12.2452C16.2537 12.5011 16.2004 12.6077 16.4136 12.8955C16.5736 13.1087 17.0746 13.5458 17.4158 13.9403C18.0341 14.6439 18.5139 15.2409 18.6418 15.6461C18.7591 16.0512 18.5565 16.2644 18.1407 16.2644Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-weibo">
            <path
                d="M15.6727 3.47929C16.0574 3.40799 17.3599 3.16657 18.6262 3.45342C20.9172 3.97043 24.0619 6.11337 22.6476 10.6737H22.6429C22.5449 11.3247 22.2104 11.3775 21.8125 11.3775C21.3366 11.3775 20.9513 11.0875 20.9513 10.6267C20.9513 10.2267 21.1225 9.82094 21.1225 9.82094C21.125 9.81243 21.1285 9.80168 21.1327 9.78872C21.211 9.54577 21.5388 8.52848 20.857 7.04579C19.54 4.90583 16.8881 4.87485 16.5744 4.99687C16.2583 5.11616 15.7924 5.17685 15.7924 5.17685C15.3134 5.17685 14.9287 4.79967 14.9287 4.34066C14.9287 3.95606 15.1948 3.63003 15.5579 3.53082C15.5579 3.53082 15.5663 3.51769 15.5794 3.51534C15.5915 3.51295 15.6036 3.50623 15.6159 3.49938C15.6303 3.49132 15.6451 3.48308 15.6605 3.48154L15.6727 3.47929Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.90229 12.4174C5.2782 12.8277 5.69688 16.1118 5.69688 16.1118C5.69688 16.1118 5.65988 17.1523 6.6686 17.6819C8.789 18.7926 10.972 18.1198 12.0756 16.7419C13.1791 15.3633 12.5313 12.0099 8.90229 12.4174ZM9.49469 15.2105C9.61574 15.4094 9.89789 15.4323 10.127 15.2667C10.3513 15.0959 10.4376 14.7979 10.3166 14.599C10.1955 14.4053 9.91633 14.3497 9.64732 14.5429C9.41592 14.7061 9.36823 15.0168 9.49469 15.2105ZM6.76709 16.1792C6.76709 16.7263 7.31159 17.1046 7.98859 17.0277C8.66266 16.9532 9.21076 16.4492 9.21076 15.9035C9.21076 15.3561 8.70493 14.9229 7.92827 14.9946C7.25074 15.0627 6.76709 15.6336 6.76709 16.1792Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.2931 11.5952C16.4372 11.4341 16.853 10.9889 16.853 10.9889C16.853 10.9889 17.6904 9.65351 16.6871 8.68256C15.4441 7.4801 12.4236 8.83565 12.4236 8.83565C11.4432 9.12977 11.5166 8.8097 11.6611 8.17989C11.6866 8.06865 11.7144 7.94776 11.7389 7.81888C11.7389 6.80728 11.3809 5.09539 8.30739 6.10636C5.23731 7.12313 2.60093 10.685 2.60093 10.685C0.767333 13.0522 1.01071 14.8815 1.01071 14.8815C1.46823 18.92 5.90299 20.0285 9.35294 20.2909C12.9818 20.5673 17.88 19.0805 19.3653 16.0283C20.8505 12.9707 18.1522 11.7608 17.2931 11.5952ZM9.62168 19.153C6.01911 19.3158 3.10645 17.5677 3.10645 15.2411C3.10645 12.9125 6.01898 11.0448 9.62168 10.8842C13.2268 10.7238 16.1453 12.1606 16.1453 14.4851C16.1453 16.8112 13.2268 18.9949 9.62168 19.153Z"
                fill="currentColor"
            />
            <path
                d="M19.0585 10.1733C19.3509 10.1733 19.599 9.96413 19.6408 9.6914C19.6456 9.67133 19.6484 9.65348 19.6484 9.63058C20.0911 5.78032 16.3882 6.44284 16.3882 6.44284C16.0595 6.44284 15.7959 6.70026 15.7959 7.02118C15.7959 7.33763 16.0595 7.59488 16.3882 7.59488C19.0478 7.02638 18.4609 9.59973 18.4609 9.59973C18.4609 9.91831 18.7293 10.1733 19.0585 10.1733Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="icon-h-youtube">
            <path
                d="M22.5574 6.94689C22.3051 6.04851 21.5602 5.33208 20.6111 5.09327C18.8931 4.66113 12.0091 4.66113 12.0091 4.66113C12.0091 4.66113 5.113 4.66113 3.39499 5.09327C2.44589 5.34345 1.71303 6.04851 1.44872 6.94689C0.992188 8.58444 0.992188 11.996 0.992188 11.996C0.992188 11.996 0.992188 15.4076 1.44872 17.0452C1.70102 17.9549 2.44589 18.66 3.39499 18.8988C5.113 19.3309 11.997 19.3309 11.997 19.3309C11.997 19.3309 18.8811 19.3309 20.5991 18.8988C21.5362 18.66 22.2931 17.9549 22.5454 17.0452C23.0019 15.4076 23.0019 11.996 23.0019 11.996C23.0019 11.996 23.0139 8.58444 22.5574 6.94689ZM9.75042 15.1006V8.90286L15.5051 11.996L9.75042 15.1006Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="id-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 5H21V19H3V5ZM10 10.0003C10 11.1048 9.10457 12.0003 8 12.0003C6.89543 12.0003 6 11.1048 6 10.0003C6 8.8957 6.89543 8.00027 8 8.00027C9.10457 8.00027 10 8.8957 10 10.0003ZM13 9.00027H19V11.5003H13V9.00027ZM19 13.4997H13V15.9997H19V13.4997ZM11 13.4997V15.9997H5V13.4997H11Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="institutional-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3L4 8V11H6V16H4V20H20V16H18V11H20V8L12 3ZM15.5 11H13.25V16H15.5V11ZM10.75 11H8.5V16H10.75V11Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="language-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.2307 20.4027C18.2316 19.2481 20.4577 16.5321 20.9137 13.25H16.9718C16.8248 16.1102 16.1791 18.638 15.2307 20.4027ZM14.473 13.25C14.2952 17.3518 13.2556 20.5 11.9998 20.5C10.744 20.5 9.70447 17.3518 9.52667 13.25H14.473ZM14.473 10.75H9.52667C9.70447 6.64821 10.744 3.5 11.9998 3.5C13.2556 3.5 14.2952 6.64821 14.473 10.75ZM16.9718 10.75H20.9137C20.4577 7.46786 18.2316 4.75191 15.2307 3.59731C16.1791 5.36198 16.8248 7.88979 16.9718 10.75ZM7.03566 10.75C7.18282 7.88774 7.82928 5.35836 8.77882 3.59353C5.77291 4.74598 3.54249 7.46427 3.08594 10.75H7.03566ZM7.03566 13.25H3.08594C3.54249 16.5357 5.77291 19.254 8.77882 20.4065C7.82928 18.6416 7.18282 16.1123 7.03566 13.25Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="log-out-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.22266 6V3H6.22266H11.7227V6L6.22266 6L6.22266 18H11.7227V21H6.22266H3.22266V18V6ZM8.59134 13.5V10.5L15.1783 10.5L15.1782 5.98418L21.2079 12L15.1783 17.9797L15.1783 13.5H8.59134Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 25 24" id="logo">
            <path
                d="M5.41406 12L2.71875 14.6953L0 12L2.71875 9.28125L5.41406 12ZM12 5.41406L16.6406 10.0547L19.3594 7.33594L12 0L4.64062 7.35938L7.35938 10.0781L12 5.41406ZM21.2812 9.28125L18.5859 12L21.3047 14.7188L24.0234 12L21.2812 9.28125ZM12 18.5859L7.35938 13.9219L4.64062 16.6406L12 24L19.3594 16.6406L16.6406 13.9219L12 18.5859ZM12 14.6953L14.7188 11.9766L12 9.28125L9.28125 12L12 14.6953Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 25 24" id="mail-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5 5.00039H3.5V19.4004H21.5V5.00039ZM3.50009 7.70036L12.4998 13.4276L21.4997 7.70039V10.9007L12.4998 16.6279L3.50016 10.9007L3.50009 7.70036Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="menu-hamburger-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 4H20V7H4V4ZM4 10.5H20V13.5H4V10.5ZM20 17H4V20H20V17Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="mode-dark">
            <path
                d="M20.9677 12.7676C19.84 13.5449 18.4732 13.9999 17 13.9999C13.134 13.9999 10 10.8659 10 6.99994C10 5.52678 10.4551 4.15991 11.2323 3.03223C6.62108 3.42175 3 7.28797 3 11.9999C3 16.9705 7.02944 20.9999 12 20.9999C16.712 20.9999 20.5782 17.3789 20.9677 12.7676Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="mode-light">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.5 2H13.5V5H10.5V2ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM5.98948 3.86891L3.86816 5.99023L5.98948 8.11155L8.1108 5.99023L5.98948 3.86891ZM2 13.5V10.5H5V13.5H2ZM3.86794 18.0095L5.98926 20.1309L8.11058 18.0095L5.98926 15.8882L3.86794 18.0095ZM13.5 19V22H10.5V19H13.5ZM18.01 15.8884L15.8887 18.0098L18.01 20.1311L20.1313 18.0098L18.01 15.8884ZM19 10.5H22V13.5H19V10.5ZM15.8894 5.99001L18.0107 8.11133L20.1321 5.99001L18.0107 3.86869L15.8894 5.99001Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="nav-collapse">
            <path d="M3 10.5V13.5L21 13.5V10.5L3 10.5Z" fill="currentColor" />
        </symbol>
        <symbol viewBox="0 0 24 24" id="nav-expand">
            <path
                d="M13.5 3H10.5V10.5L3 10.5V13.5H10.5V21H13.5V13.5H21V10.5L13.5 10.5V3Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="new-user-zone-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4507 14.4506C19.2321 9.66925 22.0109 4.69591 20.6574 3.34238C19.8978 2.58285 17.9985 3.12456 15.6328 4.59118C16.2192 4.87922 16.7663 5.23468 17.2638 5.64728C17.7491 5.49668 18.1088 5.50483 18.3019 5.69788C19.0753 6.47132 16.8808 9.91982 13.4003 13.4003C9.91981 16.8808 6.47131 19.0753 5.69787 18.3019C5.50482 18.1088 5.49667 17.7491 5.64728 17.2638C5.23468 16.7663 4.87921 16.2192 4.59117 15.6328C3.12456 17.9985 2.58285 19.8978 3.34238 20.6574C4.69591 22.0109 9.66925 19.2321 14.4507 14.4506ZM14.2384 5.62993C13.5379 5.38376 12.7845 5.24988 11.9999 5.24988C8.27196 5.24988 5.24988 8.27196 5.24988 11.9999C5.24988 12.7477 5.37149 13.4671 5.59601 14.1394C5.7729 14.6691 6.01368 15.1696 6.3092 15.6317C6.33299 15.6689 6.35713 15.7058 6.38163 15.7425C6.63746 16.1258 6.93148 16.4814 7.25824 16.804L8.18038 15.8818C9.38255 15.0571 10.8457 13.8336 12.3396 12.3397C13.8336 10.8458 15.0571 9.38259 15.8818 8.18042L16.804 7.25824C16.4814 6.93148 16.1258 6.63747 15.7425 6.38163C15.7058 6.35714 15.6689 6.333 15.6317 6.30921C15.1985 6.03216 14.7315 5.80322 14.2384 5.62993ZM11.889 18.749C11.9259 18.7496 11.9629 18.7499 11.9999 18.7499C15.7278 18.7499 18.7499 15.7278 18.7499 11.9999C18.7499 11.9629 18.7496 11.9259 18.749 11.889C17.8074 13.0804 16.7163 14.3063 15.5113 15.5113C14.3063 16.7163 13.0804 17.8074 11.889 18.749Z"
                fill="#929AA5"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="new-user-zone-new-g">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4507 14.4506C19.2321 9.66925 22.0109 4.69591 20.6574 3.34238C19.8978 2.58285 17.9985 3.12456 15.6328 4.59118C16.2192 4.87922 16.7663 5.23468 17.2638 5.64728C17.7491 5.49668 18.1088 5.50483 18.3019 5.69788C19.0753 6.47132 16.8808 9.91982 13.4003 13.4003C9.91981 16.8808 6.47131 19.0753 5.69787 18.3019C5.50482 18.1088 5.49667 17.7491 5.64728 17.2638C5.23468 16.7663 4.87921 16.2192 4.59117 15.6328C3.12456 17.9985 2.58285 19.8978 3.34238 20.6574C4.69591 22.0109 9.66925 19.2321 14.4507 14.4506ZM14.2384 5.62993C13.5379 5.38376 12.7845 5.24988 11.9999 5.24988C8.27196 5.24988 5.24988 8.27196 5.24988 11.9999C5.24988 12.7477 5.37149 13.4671 5.59601 14.1394C5.7729 14.6691 6.01368 15.1696 6.3092 15.6317C6.33299 15.6689 6.35713 15.7058 6.38163 15.7425C6.63746 16.1258 6.93148 16.4814 7.25824 16.804L8.18038 15.8818C9.38255 15.0571 10.8457 13.8336 12.3396 12.3397C13.8336 10.8458 15.0571 9.38259 15.8818 8.18042L16.804 7.25824C16.4814 6.93148 16.1258 6.63747 15.7425 6.38163C15.7058 6.35714 15.6689 6.333 15.6317 6.30921C15.1985 6.03216 14.7315 5.80322 14.2384 5.62993ZM11.889 18.749C11.9259 18.7496 11.9629 18.7499 11.9999 18.7499C15.7278 18.7499 18.7499 15.7278 18.7499 11.9999C18.7499 11.9629 18.7496 11.9259 18.749 11.889C17.8074 13.0804 16.7163 14.3063 15.5113 15.5113C14.3063 16.7163 13.0804 17.8074 11.889 18.749Z"
                fill="#929AA5"
            />
            <rect
                x="7.99988"
                y="-0.00012207"
                width={16}
                height={8}
                rx={4}
                fill="#F6465D"
            />
            <path
                d="M11.6594 3.85188L11.2274 2.98188H11.2094V5.99988H10.4594V1.81188H11.3294L12.5894 3.95988L13.0214 4.82988H13.0394V1.81188H13.7894V5.99988H12.9194L11.6594 3.85188ZM15.7499 6.07188C14.8259 6.07188 14.2739 5.42988 14.2739 4.42788C14.2739 3.43788 14.8079 2.79588 15.7259 2.79588C16.7039 2.79588 17.1539 3.51588 17.1539 4.37388V4.62588H15.0719V4.70388C15.0719 5.15388 15.3299 5.45988 15.8339 5.45988C16.2119 5.45988 16.4399 5.27988 16.6319 5.03388L17.0459 5.49588C16.7879 5.84988 16.3319 6.07188 15.7499 6.07188ZM15.7379 3.37188C15.3359 3.37188 15.0719 3.67188 15.0719 4.10388V4.15188H16.3559V4.09788C16.3559 3.66588 16.1339 3.37188 15.7379 3.37188ZM17.2543 2.86788H17.9923L18.3103 4.15788L18.5563 5.23188H18.5803L18.8683 4.15788L19.2343 2.86788H19.9303L20.3083 4.15788L20.6023 5.23188H20.6263L20.8723 4.15788L21.1843 2.86788H21.8983L21.0403 5.99988H20.2123L19.8103 4.61988L19.5763 3.76788H19.5583L19.3303 4.61988L18.9343 5.99988H18.1183L17.2543 2.86788Z"
                fill="white"
            />
        </symbol>
        <symbol viewBox="0 0 25 24" id="news-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 4H20.5V16C20.5 18.2091 18.7091 20 16.5 20H8C6.067 20 4.5 18.433 4.5 16.5V10H9V4ZM9 12.5H7V16.5C7 17.0523 7.44772 17.5 8 17.5C8.55228 17.5 9 17.0523 9 16.5V12.5ZM11.7581 7H17.7581V9H11.7581V7ZM17.7581 11H11.7581V13H17.7581V11Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="notification-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3C8.13401 3 5 6.13401 5 10L5 13L4 14V16H5L19 16H20L20 14L19 13V10C19 6.13401 15.866 3 12 3ZM12 21C9.94965 21 8.18757 19.7659 7.41602 18H16.5839C15.8124 19.7659 14.0503 21 12 21Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="orders-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 3H19V21L15.5 18L12 21L8.5 18L5 21V3ZM8 7H12V9.5H8V7ZM12 12H8V14.5H12V12ZM14 7H16.5V9.5H14V7ZM16.5 12H14V14.5H16.5V12Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="p2p-g">
            <path
                opacity="0.3"
                d="M16.75 12.25C17.9927 12.25 19 13.2574 19 14.5C19 15.7426 17.9927 16.75 16.75 16.75C15.5074 16.75 14.5 15.7425 14.5 14.4999C14.5 13.2573 15.5074 12.25 16.75 12.25Z"
                fill="#AEB4BC"
            />
            <path
                opacity="0.3"
                d="M7.25003 2.5C8.49266 2.50003 9.5 3.50743 9.5 4.75003C9.5 5.99263 8.49267 7 7.25002 7C6.00739 6.99997 5 5.99253 5 4.74994C5 3.50733 6.00737 2.5 7.25003 2.5Z"
                fill="#AEB4BC"
            />
            <path
                d="M14.25 17.5H15.2105L16.75 19.0235L18.2895 17.5001L19.25 17.5C20.3546 17.5 21.25 18.3861 21.25 19.4792V21.25L12.25 21.2499V19.4792C12.25 18.3861 13.1454 17.5 14.25 17.5Z"
                fill="url(#paint0_linear_160_28612)"
            />
            <path
                d="M4.75 7.75H5.71053L7.25 9.27347L8.78947 7.75008L9.75 7.75C10.8546 7.75 11.75 8.63612 11.75 9.72921V11.5L2.75 11.4999V9.72921C2.75 8.63612 3.64543 7.75 4.75 7.75Z"
                fill="url(#paint1_linear_160_28612)"
            />
            <circle
                cx="4.5"
                cy="4.5"
                r="4.5"
                transform="matrix(1 0 0 -1 2.75 21.25)"
                fill="#F8D33A"
            />
            <circle
                cx="3.16667"
                cy="3.16667"
                r="3.16667"
                transform="matrix(1 0 0 -1 4.0835 19.9165)"
                fill="url(#paint2_linear_160_28612)"
            />
            <path
                d="M5.62988 16.75L7.24988 18.37L8.86988 16.75L7.24988 15.13L5.62988 16.75Z"
                fill="#F0B90B"
            />
            <circle
                cx="4.5"
                cy="4.5"
                r="4.5"
                transform="matrix(1 0 0 -1 12.25 11.5)"
                fill="#F8D33A"
            />
            <ellipse
                cx="3.16667"
                cy="3.16667"
                rx="3.16667"
                ry="3.16667"
                transform="matrix(1 0 0 -1 13.5835 10.1665)"
                fill="url(#paint3_linear_160_28612)"
            />
            <path
                d="M15.1299 6.99996L16.7499 8.61996L18.3699 6.99996L16.7499 5.37996L15.1299 6.99996Z"
                fill="#F0B90B"
            />
            <path
                opacity="0.3"
                d="M21.5 16.75L22 16.25L22.5 16.75L22 17.25L21.5 16.75Z"
                fill="#AEB4BC"
            />
            <path
                opacity="0.3"
                d="M10.5 3.25L11.25 2.5L12 3.25L11.25 4L10.5 3.25Z"
                fill="#AEB4BC"
            />
            <path
                opacity="0.3"
                d="M1 13.25L1.5 12.75L2 13.25L1.5 13.75L1 13.25Z"
                fill="#AEB4BC"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28612"
                    x1="16.75"
                    y1="17.5"
                    x2="16.75"
                    y2="21.25"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_160_28612"
                    x1="7.25"
                    y1="7.75"
                    x2="7.25"
                    y2="11.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_160_28612"
                    x1="3.16667"
                    y1={0}
                    x2="3.16667"
                    y2="6.33333"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_160_28612"
                    x1="3.16667"
                    y1={0}
                    x2="3.16667"
                    y2="6.33333"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="pay-pin-g">
            <g opacity="0.6">
                <path d="M3.625 4.84814V4.09814H4.375V4.84814H3.625Z" fill="#76808F" />
            </g>
            <rect
                x="13.3491"
                y={21}
                width="2.80913"
                height="7.30374"
                transform="rotate(-90 13.3491 21)"
                fill="#76808F"
            />
            <path
                opacity="0.6"
                d="M18.2939 7.84424L17.6689 8.46924L18.2939 9.09424L18.9189 8.46924L18.2939 7.84424Z"
                fill="#76808F"
            />
            <path
                opacity="0.7"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.69141 2.97534H8.68718V5.97111H5.69141V2.97534ZM5.69141 6.97119H8.68718V9.96696H5.69141V6.97119ZM8.68718 10.967H5.69141V13.9628H8.68718V10.967ZM9.68384 2.97534H12.6796V5.97111H9.68384V2.97534ZM12.6796 6.97119H9.68384V9.96696H12.6796V6.97119ZM9.68384 10.967H12.6796V13.9628H9.68384V10.967ZM16.672 2.97534H13.6763V5.97111H16.672V2.97534Z"
                fill="#AEB4BC"
            />
            <path
                d="M16.3912 8.05208C16.3912 7.37934 15.8459 6.83398 15.1731 6.83398C14.5004 6.83398 13.955 7.37934 13.955 8.05208L13.9551 14.7893L13.1289 13.9631C12.1775 13.0117 10.635 13.0117 9.68359 13.9631L13.9113 18.1909L20.6525 18.1908V14.2161C20.6525 12.6973 19.4213 11.4661 17.9025 11.4661H16.3912L16.3912 8.05208Z"
                fill="url(#paint0_linear_159_28441)"
            />
            <path
                opacity="0.6"
                d="M6.18945 15.9629L7.18945 16.9629L8.18945 15.9629L7.18945 14.9629L6.18945 15.9629Z"
                fill="#76808F"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_159_28441"
                    x1="15.1681"
                    y1="6.83398"
                    x2="15.1681"
                    y2="18.1909"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="recurring-buy-g">
            <g opacity="0.3">
                <path
                    d="M20.0001 3.37524L20.6251 2.75024L21.2501 3.37524L20.6251 4.00024L20.0001 3.37524Z"
                    fill="#AEB4BC"
                />
                <path
                    d="M20.0001 20.9668L21.0001 19.9668L22.0001 20.9668L21.0001 21.9668L20.0001 20.9668Z"
                    fill="#AEB4BC"
                />
                <path d="M4 20.0002H3.25V20.7502H4V20.0002Z" fill="#AEB4BC" />
            </g>
            <path
                d="M4 11.9829L4 11.9287L2 11.9287V11.9829C1.99989 14.5407 2.9764 17.1019 4.92893 19.0544C8.83417 22.9597 15.1658 22.9597 19.0711 19.0544L21.2993 16.8262L22.7186 18.2454V13.9927H18.4658L19.8851 15.412L17.6569 17.6402C14.5327 20.7644 9.46734 20.7644 6.34315 17.6402C4.78076 16.0778 3.9999 14.032 4 11.9829Z"
                fill="url(#paint0_linear_160_28812)"
            />
            <ellipse
                cx="4.99999"
                cy="4.99999"
                rx="4.99999"
                ry="4.99999"
                transform="matrix(1 0 0 -1 7 16.9644)"
                fill="url(#paint1_linear_160_28812)"
            />
            <path
                opacity="0.3"
                d="M17.6568 6.28846C14.5326 3.16426 9.46729 3.16426 6.34309 6.28846L4.11485 8.5167L5.534 9.93586H1.28125L1.28125 5.68311L2.70063 7.10249L4.92888 4.87424C8.83412 0.969002 15.1658 0.969001 19.071 4.87424C21.0235 6.82678 22.0001 9.38792 21.9999 11.9457V11.9999H19.9999V11.9457C20 9.89669 19.2192 7.85085 17.6568 6.28846Z"
                fill="#AEB4BC"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4835 14.3282V15.0057H11.679V14.3564C10.9663 14.2929 10.4935 14.0036 10.1406 13.6155L10.7757 13.0368C11.0439 13.3191 11.3756 13.5096 11.7708 13.5661V12.2958C10.7122 12.0771 10.2818 11.6113 10.2818 10.9268C10.2818 10.1858 10.7687 9.69181 11.679 9.58596V8.92261H12.4835V9.58596C13.0481 9.64947 13.4644 9.86824 13.7749 10.2211L13.1328 10.7997C12.9634 10.6092 12.7376 10.454 12.3988 10.3763V11.5478C13.3868 11.7736 13.8596 12.1758 13.8596 12.8957C13.8596 13.5872 13.4221 14.173 12.4835 14.3282ZM11.7708 10.3622C11.4109 10.4328 11.2556 10.6233 11.2556 10.8985C11.2556 11.1667 11.4109 11.3078 11.7708 11.4066V10.3622ZM12.3988 13.5519C12.7305 13.4602 12.8858 13.2414 12.8858 12.9733C12.8858 12.7686 12.8011 12.5569 12.3988 12.437V13.5519Z"
                fill="#76808F"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28812"
                    x1="12.3593"
                    y1="11.9287"
                    x2="12.3593"
                    y2="21.9833"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_160_28812"
                    x1="4.99999"
                    y1={0}
                    x2="4.99999"
                    y2="9.99998"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="referral-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 8.5C11 10.433 9.433 12 7.5 12C5.567 12 4 10.433 4 8.5C4 6.567 5.567 5 7.5 5C9.433 5 11 6.567 11 8.5ZM2 17C2 15.3431 3.34315 14 5 14H10C11.6569 14 13 15.3431 13 17V20H2V17ZM16.5 16V13H13.5V10H16.5V7H19.5V10H22.5V13H19.5V16H16.5Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="reward-center-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 5H21V9C19.3431 9 18 10.3431 18 12C18 13.6569 19.3431 15 21 15V19H3V15C4.65685 15 6 13.6569 6 12C6 10.3431 4.65685 9 3 9V5ZM15.5 7.5H13V16.5H15.5V7.5Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="search-f">
            {" "}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 6C13.7614 6 16 8.23858 16 11C16 13.7614 13.7614 16 11 16C8.23857 16 6 13.7614 6 11C6 8.23858 8.23858 6 11 6ZM11 3C15.4183 3 19 6.58172 19 11C19 12.3907 18.6451 13.6985 18.021 14.8379L21.0915 17.9086L19.5006 19.4995L17.9097 21.0904L14.8396 18.0201C13.6999 18.6448 12.3914 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="security-authenticator-google-g">
            <path
                opacity="0.3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2L12 23L21 17V2L12 2ZM18.25 9.125L18.875 9.75L19.5 9.125L18.875 8.5L18.25 9.125ZM16 4H15V3H16V4Z"
                fill="#AEB4BC"
            />
            <path
                opacity="0.3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 23L3 17.0107V2H12V23ZM5.75 12L4.75 11L5.75 10L6.75 11L5.75 12Z"
                fill="url(#paint0_linear_160_28705)"
            />
            <circle cx={12} cy={8} r={4} fill="url(#paint1_linear_160_28705)" />
            <path
                d="M12 4C9.79086 4 8 5.79086 8 8C8 9.10457 8.44772 10.1046 9.17157 10.8284L12 8V4Z"
                fill="url(#paint2_linear_160_28705)"
            />
            <path
                d="M6 17L18 17L18 13L6 13L6 17Z"
                fill="url(#paint3_linear_160_28705)"
            />
            <path
                d="M12.75 14.5L16.5 14.5L16.5 15.5L12.75 15.5L12.75 14.5Z"
                fill="url(#paint4_linear_160_28705)"
            />
            <path
                d="M7.5 14.5L11.25 14.5L11.25 15.5L7.5 15.5L7.5 14.5Z"
                fill="url(#paint5_linear_160_28705)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28705"
                    x1={12}
                    y1={23}
                    x2={12}
                    y2={2}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#AEB4BC" stopOpacity="0.1" />
                    <stop offset="0.700556" stopColor="#AEB4BC" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_160_28705"
                    x1={12}
                    y1={4}
                    x2={12}
                    y2={12}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_160_28705"
                    x1={10}
                    y1={4}
                    x2={10}
                    y2="10.8284"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_160_28705"
                    x1={18}
                    y1={15}
                    x2={6}
                    y2={15}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_160_28705"
                    x1="7.5"
                    y1={15}
                    x2="16.5"
                    y2={15}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_160_28705"
                    x1="7.5"
                    y1={15}
                    x2="16.5"
                    y2={15}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="security-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 4V16L12 21L20 16V4H4ZM12 8L8.5 11.5L12 15L15.5 11.5L12 8Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="solutions-g">
            <rect
                opacity="0.3"
                x="2.5"
                y="2.5"
                width="3.5"
                height="3.5"
                fill="#AEB4BC"
            />
            <rect opacity="0.3" x={18} y={18} width="3.5" height="3.5" fill="#AEB4BC" />
            <rect
                width="4.5"
                height={10}
                transform="matrix(1 0 0 -1 2.5 17)"
                fill="url(#paint0_linear_160_28640)"
            />
            <rect
                width={7}
                height={10}
                transform="matrix(1 0 0 -1 14.5 17)"
                fill="url(#paint1_linear_160_28640)"
            />
            <rect
                width="4.5"
                height={10}
                transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 17 21.5)"
                fill="url(#paint2_linear_160_28640)"
            />
            <rect
                width="4.5"
                height={10}
                transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 17 7)"
                fill="url(#paint3_linear_160_28640)"
            />
            <path
                d="M13.25 4.5H10.75V7H7V10.75H4.5V13.25H7V17H10.75V19.5H13.25V17H17V13.25H14.5V10.75H17V7H13.25V4.5Z"
                fill="url(#paint4_linear_160_28640)"
            />
            <path
                opacity="0.3"
                d="M18.5 4.25L19.75 5.5L21 4.25L19.75 3L18.5 4.25Z"
                fill="#AEB4BC"
            />
            <path
                opacity="0.3"
                d="M4 21.125L4.875 22L5.75 21.125L4.875 20.25L4 21.125Z"
                fill="#AEB4BC"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28640"
                    x1="2.25"
                    y1={0}
                    x2="2.25"
                    y2={10}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_160_28640"
                    x1="3.5"
                    y1={0}
                    x2="3.5"
                    y2={10}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_160_28640"
                    x1="2.25"
                    y1={0}
                    x2="2.25"
                    y2={10}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_160_28640"
                    x1="2.25"
                    y1={0}
                    x2="2.25"
                    y2={10}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_160_28640"
                    x1="10.75"
                    y1="19.5"
                    x2="10.75"
                    y2="4.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F0B90B" />
                    <stop offset={1} stopColor="#F8D33A" />
                </linearGradient>
            </defs>
        </symbol>
        <symbol viewBox="0 0 24 24" id="subaccount-s24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 8.5C12 10.433 10.433 12 8.5 12C6.567 12 5 10.433 5 8.5C5 6.567 6.567 5 8.5 5C10.433 5 12 6.567 12 8.5ZM3 17C3 15.3431 4.34315 14 6 14H11C12.6569 14 14 15.3431 14 17V20H3V17ZM21 5H16V8H21V5ZM21 10.002H16V13.002H21V10.002ZM16 15.0039H21V18.0039H16V15.0039Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 16 16" id="tag-vip-s16">
            <g>
                <path
                    d="M11.991 3H3.974L0 6.98 7.991 15 16 6.98 11.991 3z"
                    fill="url(#paint0_linear)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear"
                        x1={8}
                        y1={3}
                        x2={8}
                        y2={15}
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#F8D12F" />
                        <stop offset={1} stopColor="#F0B90B" />
                    </linearGradient>
                </defs>
            </g>
        </symbol>
        <symbol viewBox="0 0 24 24" id="task-center-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2H9V4H5V21H19V4H15V2ZM16 9H8V11.5H16V9ZM16 14.5H8V17H16V14.5Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="user-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8ZM8 14C5.79086 14 4 15.7909 4 18V20H20V18C20 15.7909 18.2091 14 16 14H8Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="verified-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.8234 5.33928L14.4311 2.92773L12.0195 4.32L9.60801 2.92773L8.2157 5.33928H5.43074V8.12408L3.01953 9.51617L4.41186 11.9277L3.01958 14.3393L5.43074 15.7314V18.5162H8.21567L9.60798 20.9277L12.0195 19.5354L14.4311 20.9277L15.8234 18.5162H18.6076V15.7318L21.0195 14.3393L19.6272 11.9277L21.0195 9.51618L18.6076 8.12364V5.33928H15.8234ZM10.86 12.4475L15.2913 8.01562L17.0591 9.78339L10.86 15.983L6.94067 12.0633L8.70844 10.2956L10.86 12.4475Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="wallet-f">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 8.5C4 6.01472 6.01472 4 8.5 4H20V20H8.5C6.01472 20 4 17.9853 4 15.5V8.5ZM8.5 7H17V10H8.5C7.67157 10 7 9.32843 7 8.5C7 7.67157 7.67157 7 8.5 7ZM13 13H17V17H13V13Z"
                fill="currentColor"
            />
        </symbol>
        <symbol viewBox="0 0 24 24" id="xrpoptions-g">
            <path
                opacity="0.3"
                d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22L12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4L12 2Z"
                fill="#AEB4BC"
            />
            <path
                d="M2 12C2 6.47715 6.47715 2 12 2V4C7.58172 4 4 7.58172 4 12C4 14.2094 4.89434 16.208 6.34315 17.6569L7.75 16.25V20.5H3.5L4.92893 19.0711C3.12038 17.2625 2 14.7611 2 12Z"
                fill="url(#paint0_linear_160_28594)"
            />
            <path
                d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
                fill="white"
            />
            <path
                d="M14.1323 9.5H15.0055L13.1887 11.2981C12.531 11.9489 11.4647 11.9489 10.8071 11.2981L8.99023 9.5H9.8635L11.2437 10.8659C11.6602 11.2782 12.3355 11.2782 12.7521 10.8659L14.1323 9.5Z"
                fill="#23292F"
            />
            <path
                d="M9.85227 14.5001H8.979L10.8071 12.6909C11.4647 12.04 12.531 12.04 13.1887 12.6909L15.0167 14.5001H14.1435L12.752 13.123C12.3355 12.7108 11.6602 12.7108 11.2437 13.123L9.85227 14.5001Z"
                fill="#23292F"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_160_28594"
                    x1={7}
                    y1={2}
                    x2={7}
                    y2="20.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#929AA5" />
                    <stop offset={1} stopColor="#76808F" />
                </linearGradient>
            </defs>
        </symbol>
    </svg>
    );
}

export default CommonSvgs;